import Vue from "vue";
import Router from "vue-router";

/* eslint-disable */

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: { name: "Login" }
    },
    {
      path: "/Main",
      name: "Main",
      component: () => import("./views/Main.vue"),
      children: [
        {
          path: "ChargingReport",
          name: "Charging Report",
          component: () => import("./views/ChargingReport")
        },
        {
          path: "EnergyReport",
          name: "Energy Report",
          component: () => import("./views/EnergyReport")
        },
        {
          path: "ACCurrentChart",
          name: "AC Current Chart",
          component: () => import("./views/ACCurrentChart")
        },
        {
          path: "AlertReport",
          name: "Alert Report",
          component: () => import("./views/AlertReport")
        },
        {
          path: "ChargerStatusMonitor",
          name: "Charger Status Monitor",
          component: () => import("./views/ChargerStatusMonitor")
        },
        {
          path: "ConnectionHistory",
          name: "Connection History",
          component: () => import("./views/ConnectionHistory")
        },
        {
          path: "Configure",
          name: "Configure",
          component: () => import("./views/Configure/index.vue")
        },
        {
          path: "CustomerConfigure",
          name: "Configure ",
          component: () => import("./views/CustomerConfigure/index.vue")
        }
      ]
    },
    {
      path: "/Login",
      name: "Login",
      component: () => import("./views/Login.vue")
    },
    {
      path: "/Register",
      name: "Register",
      component: () => import("./views/Register.vue")
    }
  ]
});
